$(document).ready(function(){
$('.slick-track1').slick({
  dots:true,
  infinite: true,
  autoplay: true,
  speed: 350,
  slidesToShow:2,
  slidesToScroll:2,
  responsive: [
    {
      breakpoint:1000,
      settings: {
        slidesToShow:1,
        slidesToScroll:1,
        infinite: true,
        dots:  true
      }
    },
	{
      breakpoint:600,
      settings: {
        slidesToShow:1,
        slidesToScroll:1,
        infinite: true,
        dots:  true
      }
    }
  ]
});
});


$(document).ready(function(){
$('.slick-track2').slick({
  dots:true,
  infinite: true,
  autoplay: false,
  speed: 350,
  slidesToShow:3,
  slidesToScroll:3,
  responsive: [
    {
      breakpoint:1000,
      settings: {
        slidesToShow:2,
        slidesToScroll:2,
        infinite: true,
        dots:  true
      }
    },
	{
      breakpoint:600,
      settings: {
        slidesToShow:1,
        slidesToScroll:1,
        infinite: true,
        dots:  true
      }
    }
  ]
});
});
